/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/*
Add only those constants whose values are meaningful.
Eg: MIN_ZOOM = 0.1 //its value is important for setting initial default minimum zoom level.
Dont' declare enums here, Have a look at enums.js to find out right place to put constants.
*/

export const GRABBER_SIZE = 25;
export const OUTER_GRABBER_SIZE = 50;

export const DEFAULT_QUAD_COLOR = {
  red: 20,
  green: 115,
  blue: 230,
  alpha: 0.2
};
export const GENAI_QUAD_COLOR = {
  red: 90,
  green: 96,
  blue: 235,
  alpha: 0.4
};
export const CURSOR_COLOR = "black";
export const CURSOR_WIDTH = 1;
export const SELECTION_PRIORITY = 10;

export const ADVANCE_TEXT_EDITING_MAX_INPUT_LENGTH = 5;

export const COLOR_PALETTE_SIZE = 3;
export const HC_COLOR_SPACE = "rgb";
export const FC_ACTIVE = "ACTIVE";
export const HC_BUTTON_SELECTED_STYLE = {
  background: "Highlight",
  text: "HighlightText",
  borderColor: "Highlight"
};
export const HC_BUTTON_DEF_STYLE = {
  background: "ButtonFace",
  text: "ButtonText"
};
export const APP_THEMES = Object.freeze({
  LIGHT: "light",
  DARK: "dark"
});
export const BUTTON_STYLES = Object.freeze({
  DEFAULT_LIGHT: {
    color: "var(--spectrum-global-color-gray-800)",
    background: "transparent"
  },
  DEFAULT_DARK: {
    color: "var(--spectrum-global-color-gray-700)",
    background: "transparent"
  },
  HOVER: {
    color: "var(--spectrum-global-color-gray-900)",
    background: "transparent"
  },
  ACTIVE: {
    color: "var(--spectrum-global-color-gray-900)",
    background: "var(--spectrum-global-color-gray-300)"
  },
  SELECTED: {
    color: "var(--spectrum-global-color-gray-900)",
    background: "var(--spectrum-global-color-gray-300)"
  }
});

export const reviewPathName = "/link/review";
export const trackPathName = "/link/track";
export const INTERACTIVE_ARIA_ROLES =
  'button:not([disabled]), input[type="text"]:not([disabled]), input[type="search"]:not([disabled]), [role="tab"], [role="switch"], [role="button"], [role="textbox"]';

export const TOOLTIP = Object.freeze({
  DELAY: "500",
  PLACEMENT: Object.freeze({
    TOP: "top",
    BOTTOM: "bottom",
    LEFT: "left",
    RIGHT: "right"
  }),
  TRIGGER: Object.freeze({
    HOVER: "hover"
  })
});

export const FONT_SIZE = Object.freeze({
  MIN: 0.1,
  MAX: 1296,
  WIDTH: "80px",
  MENU_WIDTH: "87px"
});

export const KEY_CODES = Object.freeze({
  ENTER: "Enter"
});

export const pageContentTypes = {
  NONE: 0,
  TEXT: 1,
  HYPERLINK: 2,
  UNKNOWN: 3,
  IMAGE: 4
};

export const IMAGE_BORDER = Object.freeze({
  COLOR: "var(--spectrum-global-color-gray-600)",
  SIZE: "var(--spectrum-global-dimension-size-10)",
  STYLE: "solid"
});
